import i18next from 'i18next';
import IntlMessageFormat from 'intl-messageformat';
export { default as IntlMessageFormat } from 'intl-messageformat';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Currency code list
 * https://www.currency-iso.org/en/home/tables/table-a1.html
 */
var currency = ['AFN', 'EUR', 'ALL', 'DZD', 'USD', 'AOA', 'XCD', 'ARS', 'AMD', 'AWG', 'AUD', 'AZN', 'BSD', 'BHD', 'BDT', 'BBD', 'BYN', 'BZD', 'XOF', 'BMD', 'INR', 'BTN', 'BOB', 'BOV', 'BAM', 'BWP', 'NOK', 'BRL', 'BND', 'BGN', 'BIF', 'CVE', 'KHR', 'XAF', 'CAD', 'KYD', 'CLP', 'CLF', 'CNY', 'COP', 'COU', 'KMF', 'CDF', 'NZD', 'CRC', 'HRK', 'CUP', 'CUC', 'ANG', 'CZK', 'DKK', 'DJF', 'DOP', 'EGP', 'SVC', 'ERN', 'ETB', 'FKP', 'FJD', 'XPF', 'GMD', 'GEL', 'GHS', 'GIP', 'GTQ', 'GBP', 'GNF', 'GYD', 'HTG', 'HNL', 'HKD', 'HUF', 'ISK', 'IDR', 'XDR', 'IRR', 'IQD', 'ILS', 'JMD', 'JPY', 'JOD', 'KZT', 'KES', 'KPW', 'KRW', 'KWD', 'KGS', 'LAK', 'LBP', 'LSL', 'ZAR', 'LRD', 'LYD', 'CHF', 'MOP', 'MKD', 'MGA', 'MWK', 'MYR', 'MVR', 'MRO', 'MUR', 'XUA', 'MXN', 'MXV', 'MDL', 'MNT', 'MAD', 'MZN', 'MMK', 'NAD', 'NPR', 'NIO', 'NGN', 'OMR', 'PKR', 'PAB', 'PGK', 'PYG', 'PEN', 'PHP', 'PLN', 'QAR', 'RON', 'RUB', 'RWF', 'SHP', 'WST', 'STD', 'SAR', 'RSD', 'SCR', 'SLL', 'SGD', 'XSU', 'SBD', 'SOS', 'SSP', 'LKR', 'SDG', 'SRD', 'SZL', 'SEK', 'CHE', 'CHW', 'SYP', 'TWD', 'TJS', 'TZS', 'THB', 'TOP', 'TTD', 'TND', 'TRY', 'TMT', 'UGX', 'UAH', 'AED', 'USN', 'UYU', 'UYI', 'UZS', 'VUV', 'VEF', 'VND', 'YER', 'ZMW', 'ZWL', 'XBA', 'XBB', 'XBC', 'XBD', 'XTS', 'XXX', 'XAU', 'XPD', 'XPT', 'XAG'];
var numberFormat = {};

for (var i = 0; i < currency.length; i++) {
  numberFormat[currency[i]] = {
    style: 'currency',
    currency: currency[i]
  };
}

var defaultFormats = {
  number: numberFormat
};

var types = {
  LOGGER: 'logger',
  LAMGUAGE_DETECTOR: 'languageDetector',
  LAMGUAGE_TRANSFORMER: 'languageTransformer',
  BACKEND: 'backend'
};
function isTypes(type) {
  return function (itm) {
    return itm.type === type;
  };
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function getLastOfPath(object, path, Empty) {
  if (Empty === void 0) {
    Empty = null;
  }

  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _a = getLastOfPath(object, path, Object),
      obj = _a.obj,
      k = _a.k;

  obj[k] = newValue;
}

function getPath(object, path) {
  var _a = getLastOfPath(object, path),
      obj = _a.obj,
      k = _a.k;

  if (!obj) return undefined;
  return obj[k];
}

var ON_PARSE_ERROR_STRATEGY;

(function (ON_PARSE_ERROR_STRATEGY) {
  ON_PARSE_ERROR_STRATEGY["keepRaw"] = "keepRaw";
  ON_PARSE_ERROR_STRATEGY["replaceAnyway"] = "replaceAnyway"; // 保留部分插值
})(ON_PARSE_ERROR_STRATEGY || (ON_PARSE_ERROR_STRATEGY = {}));

var DEFAULT_ON_PARSE_ERROR_STRATEGY = ON_PARSE_ERROR_STRATEGY.replaceAnyway;
var DEFAULT_OPTIONS = {
  memoize: false,
  memoizeFallback: false,
  bindI18n: false,
  bindI18nStore: false,
  onParseError: ON_PARSE_ERROR_STRATEGY.replaceAnyway
};

var IES_INTL_ICU_PLUGIN =
/** @class */
function () {
  function IES_INTL_ICU_PLUGIN() {
    this.mem = {};
  }

  IES_INTL_ICU_PLUGIN.staticInit = function (i18next) {
    IES_INTL_ICU_PLUGIN._i18nextInstance = i18next;
  };

  IES_INTL_ICU_PLUGIN.prototype.init = function (i18next, options) {
    var _this = this;

    if (i18next === void 0) {
      i18next = IES_INTL_ICU_PLUGIN._i18nextInstance;
    }

    var i18nextOptions = {};

    if (!!(i18next === null || i18next === void 0 ? void 0 : i18next.options)) {
      if (!!i18next.options.i18nFormat) {
        i18nextOptions = i18next.options.i18nFormat;
      }

      i18nextOptions.onParseError = i18next.options.onParseError;
      i18nextOptions.missingInterpolationHandler = i18next.options.missingInterpolationHandler;
      i18nextOptions.icuConfig = i18next.options.icuConfig;
      i18nextOptions.ignoreWarning = !!i18next.options.ignoreWarning;
    }

    this.options = Object.assign(DEFAULT_OPTIONS, options, i18nextOptions);
    this.formats = this.options.formats;

    if (i18next) {
      var _a = this.options,
          bindI18n = _a.bindI18n,
          bindI18nStore = _a.bindI18nStore,
          memoize = _a.memoize;
      i18next.IntlMessageFormat = IntlMessageFormat;
      this.IntlMessageFormat = IntlMessageFormat;
      i18next.ICU = this;

      if (memoize) {
        if (bindI18n) {
          i18next.on(bindI18n, function () {
            return _this.clearCache();
          });
        }

        if (bindI18nStore) {
          i18next.store.on(bindI18nStore, function () {
            return _this.clearCache();
          });
        }
      }
    }

    if (this.options.localeData) {
      if (Object.prototype.toString.apply(this.options.localeData) === '[object Array]') {
        this.options.localeData.forEach(function (ld) {
          return _this.addLocaleData(ld);
        });
      } else {
        this.addLocaleData(this.options.localeData);
      }
    }
  };

  IES_INTL_ICU_PLUGIN.prototype.addLocaleData = function (data) {
    var locales = Object.prototype.toString.apply(data) === '[object Array]' ? data : [data];
    locales.forEach(function (localeData) {
      if (localeData && localeData.locale) {
        IntlMessageFormat.__addLocaleData(localeData); // IntlRelativeFormat.__addLocaleData(localeData);

      }
    });
  };

  IES_INTL_ICU_PLUGIN.prototype.addUserDefinedFormats = function (formats) {
    this.formats = this.formats ? _assign(_assign({}, this.formats), formats) : formats;
  };

  IES_INTL_ICU_PLUGIN.prototype.checkMissingInterpolation = function (icuAST, messageText, options, lng, key) {
    // ICU Config Strict 为 false，不检查插值缺失
    if ((this.options.icuConfig || {}).strict === false) {
      return options;
    } // 记录所有丢失的插值参数


    var missingInterpolations = {};

    for (var _i = 0, icuAST_1 = icuAST; _i < icuAST_1.length; _i++) {
      var element = icuAST_1[_i]; // if (element.type !== TYPE.argument) {
      //   continue;
      // }
      // 1 === argument，没必要因为这个引入隐式依赖

      if (element.type !== 1) {
        continue;
      } // 这个节点是参数表达式


      var value = element.value; // id 就是插值参数名

      if (options[value] !== null && options[value] !== undefined) {
        continue;
      }

      if (typeof this.options.missingInterpolationHandler === 'function') {
        // 权重最高
        var ans = this.options.missingInterpolationHandler({
          key: key,
          text: messageText,
          locale: lng,
          interpolation: {
            key: value,
            val: options[value]
          }
        });

        if (typeof ans === 'string') {
          missingInterpolations[value] = ans;
          continue;
        }
      }

      switch (this.options.onParseError) {
        // 插值参数丢失策略：保留全部翻译文案，不进行任何插值替换
        case ON_PARSE_ERROR_STRATEGY.keepRaw:
          throw new Error();
        // 插值参数丢失策略：替换丢失的这个文案为 Key 值

        case ON_PARSE_ERROR_STRATEGY.replaceAnyway:
          missingInterpolations[value] = "{" + value + "}";
          continue;
      }

      if (typeof this.options.onParseError === 'function') {
        // deprecated
        // 业务配置了 onParseError callback
        console.warn('[DEPRECATED] onParseError is deprecated, please use \'missingInterpolationHandler\' instead of');
        var callbackReturns = this.options.onParseError(messageText, value, lng, this.IntlMessageFormat);

        if (callbackReturns === true) {
          // 业务期望保留全部翻译文案，不进行插值替换
          throw new Error();
        }

        missingInterpolations[value] = typeof callbackReturns === 'string' ? callbackReturns : "{" + value + "}";
      } else {
        // 默认兜底
        if (!this.options.ignoreWarning) {
          // 发生了插值参数丢失
          console.warn("[Starling ICU Warning] The interpolation parameter \"{" + value + "}\" is missing in the translation text \"" + messageText + "\" for the key \"" + key + "\"\nSuggestions: check whether the value is null or undefined. Try using empty string '' as fallback! e.g I18n.t('key', { apple: count || '' })");
        }

        missingInterpolations[value] = "{" + value + "}";
      }
    }

    return Object.assign({}, options, missingInterpolations);
  };

  IES_INTL_ICU_PLUGIN.prototype.parse = function (res, options, lng, ns, key, info) {
    var hadSuccessfulLookup = info && info.resolved && info.resolved.res;
    var memKey = this.options.memoize && lng + "." + ns + "." + key.replace(/\./g, '###');

    if (!hadSuccessfulLookup && options.thirdParamFallback && options.fallbackText) {
      res = options.fallbackText;
    }

    var fc;

    if (this.options.memoize) {
      fc = getPath(this.mem, memKey);
    }

    try {
      if (!fc) {
        fc = new this.IntlMessageFormat(res, lng, this.formats, (this.options.icuConfig || {}).formatOptions);

        if (this.options.memoize && (this.options.memoizeFallback || !info || hadSuccessfulLookup)) {
          setPath(this.mem, memKey, fc);
        }
      }

      return fc.format(this.checkMissingInterpolation(fc.getAst(), res, options || {}, lng, key));
    } catch (err) {
      // if (!this.options.ignoreWarning) {
      //   console.log(err);
      // }
      return res;
    }
  };

  IES_INTL_ICU_PLUGIN.prototype.addLookupKeys = function (finalKeys, key, code, ns, options) {
    // no additional keys needed for select or plural
    // so there is no need to add keys to that finalKeys array
    return finalKeys;
  };

  IES_INTL_ICU_PLUGIN.prototype.clearCache = function () {
    this.mem = {};
  };

  IES_INTL_ICU_PLUGIN.type = 'i18nFormat';
  IES_INTL_ICU_PLUGIN._i18nextInstance = null;
  return IES_INTL_ICU_PLUGIN;
}();

function formatLang(lng, plugins) {
  var formatLang = lng;
  (plugins || []).map(function (plugin) {
    formatLang = plugin.process(lng) || formatLang;
  });
  return formatLang;
}

var defaultFallbackLanguage = 'zh-CN';
var defaultConfig = {
  lng: defaultFallbackLanguage,
  fallbackLng: ['en-US']
};
var defaultPlugins = [IES_INTL_ICU_PLUGIN];
/**
 * I18n内核
 * 安全校验
 */

var I18next = /*#__PURE__*/function () {
  function I18next(config, plugins) {
    var _this = this;

    _classCallCheck(this, I18next);

    this.t = function (keys, options, fallbackText) {
      var separatorMock = Array.isArray(keys) ? Array.from(keys).map(function () {
        return ' ';
      }).join('') : Array(keys.length).fill(' '); // fixed: 去除默认lngs，有lngs i18next就会忽略lng

      var opt = Object.assign({
        keySeparator: separatorMock,
        nsSeparator: separatorMock
      }, options);

      if ('thirdParamFallback' in _this.config && _this.config.thirdParamFallback) {
        opt.thirdParamFallback = true;
      }

      return _this.instance.t(keys, fallbackText, opt);
    };

    this.plugins = Array.isArray(plugins) ? plugins.concat(defaultPlugins) : defaultPlugins;
    this.userLng = config.lng || null; // 用户自己设定的 lng

    this.config = Object.assign({}, defaultConfig, config);
  }

  _createClass(I18next, [{
    key: "language",
    get: function get() {
      return (this.instance || {}).language;
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.instance = i18next.createInstance(); // fixed: 非浏览器环境不支持incontext
        // fixed: Cocos 有 window 但不使用 in-context

        if (typeof window !== 'undefined' && !!window.CocosEngine) {
          // eslint-disable-next-line @typescript-eslint/no-var-requires
          _this2.plugins.push(require('@ies/intl-incontext-plugin')["default"]);

          _this2.config.postProcess = [].concat(['inContext'], _this2.config.postProcess || []);
        }

        _this2.plugins.map(function (p) {
          if (p.name === 'IES_INTL_ICU_PLUGIN') {
            p.staticInit(_this2.instance);
          }

          _this2.instance.use(p);
        });

        var config = _this2.config;
        _this2.config.formats = Object.assign({}, _this2.config.formats, defaultFormats);
        var formatLng = formatLang(config.lng, _this2.plugins.filter(isTypes(types.LAMGUAGE_TRANSFORMER)));

        _this2.instance.init(Object.assign({}, config, {
          lng: formatLng,
          i18nFormat: {
            formats: _this2.config.formats
          }
        }), function (err, t) {
          if (!err) {
            _this2._updateLanguages();

            resolve({
              t: t,
              err: err
            });
          }

          _this2.init = true;
          reject({
            t: t,
            err: err
          });
        });
      });
    }
  }, {
    key: "_updateLanguages",
    value: function _updateLanguages() {
      this.languages = this.instance ? Array.from(new Set([this.instance.language].concat(_toConsumableArray(this.instance.languages)))) : null;
    }
  }, {
    key: "getLanguages",
    value: function getLanguages() {
      return this.languages;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this3 = this;

      this.config.lng = lng;
      this.instance.changeLanguage(lng, function (err, t) {
        if (!err) {
          _this3._updateLanguages();
        }

        callback && callback(err, t);
      });
    }
  }, {
    key: "changeLanguageWithPromise",
    value: function changeLanguageWithPromise(lng) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        _this4.config.lng = lng;

        _this4.instance.changeLanguage(lng, function (err, t) {
          if (err) {
            reject({
              err: err,
              t: t
            });
          }

          _this4._updateLanguages();

          resolve({
            err: err,
            t: t
          });
        });
      });
    }
  }, {
    key: "getDir",
    value: function getDir(lng) {
      return this.instance.dir(lng);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      return this.instance.addResourceBundle(lng, ns, resources, deep, overwrite);
    }
  }]);

  return I18next;
}();

var PREFIX = 'Starling_intl:';
var logger = {
  warn: function warn() {
    var _console;

    var prefix = "".concat(PREFIX, " [WARNING]");

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    (_console = console).warn.apply(_console, [prefix].concat(args));
  },
  error: function error() {
    var _console2;

    var prefix = "".concat(PREFIX, " [ERROR]");

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    (_console2 = console).error.apply(_console2, [prefix].concat(args));
  }
};

function promiseQueue(executors) {
  return new Promise(function (resolve, reject) {
    if (!Array.isArray(executors)) {
      executors = Array.from(executors);
    }

    if (executors.length <= 0) {
      return resolve([]);
    }

    var res = [];
    executors = executors.map(function (x, i) {
      return function () {
        var p = typeof x === 'function' ? new Promise(x) : Promise.resolve(x);
        p.then(function (response) {
          res[i] = response;

          if (i === executors.length - 1) {
            resolve(res);
          } else {
            executors[i + 1]();
          }
        }, reject);
      };
    });
    executors[0]();
  });
}

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }

  if (result && result.then) {
    return result.then(void 0, recover);
  }

  return result;
}

function _empty() {}

function _awaitIgnored(value, direct) {
  if (!direct) {
    return value && value.then ? value.then(_empty) : Promise.resolve();
  }
}

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

var IntlModuleType;

(function (IntlModuleType) {
  IntlModuleType["intl3rdParty"] = "intl3rdParty";
  IntlModuleType["backend"] = "backend";
  IntlModuleType["logger"] = "logger";
  IntlModuleType["languageDetector"] = "languageDetector";
  IntlModuleType["postProcessor"] = "postProcessor";
  IntlModuleType["i18nFormat"] = "i18nFormat";
  IntlModuleType["3rdParty"] = "3rdParty";
})(IntlModuleType || (IntlModuleType = {}));
/**
 * I18n实例
 * 自定义配置
 */

var Intl = /*#__PURE__*/function () {
  function Intl() {
    var _this = this;

    _classCallCheck(this, Intl);

    this.t = function (keys, options, fallbackText) {
      if (!_this.ignoreWarning && (!_this.i18nInstance || !_this.i18nInstance.init)) {
        logger.error("The instance has not been initialized: i18n.t('".concat(keys, "'").concat(options ? ',' + JSON.stringify(options) : '', ");"));
        return fallbackText || Array.isArray(keys) ? keys[0] : keys;
      } // 有人给 key 传空字符串?


      if (!keys || typeof keys === 'string' && !keys.trim()) {
        return '';
      }

      return _this.i18nInstance.t(keys, options, fallbackText);
    };

    this.plugins = [];
  }

  _createClass(Intl, [{
    key: "use",
    value: function use(plugin) {
      if (!this.plugins.includes(plugin)) {
        this.plugins.push(plugin);
        return this;
      }

      logger.warn('Plugin: %s has beeninit installed.', plugin.name);
      return this;
    }
  }, {
    key: "init",
    value: function init(config, initCallback) {
      try {
        var _this3 = this;

        // ignore warning
        _this3.ignoreWarning = config.ignoreWarning;
        _this3.i18nInstance = new I18next(config, _this3.plugins);
        return _catch(function () {
          return _await(_this3.i18nInstance.createInstance(), function (_ref) {
            var err = _ref.err,
                t = _ref.t;

            // 接入 Intl thirdParty 类型 Plugin
            var intlThirdPartyArray = _this3.plugins.filter(function (p) {
              return p.type === IntlModuleType.intl3rdParty;
            });

            return _await(promiseQueue(intlThirdPartyArray.map(_async(function (intlThirdParty) {
              if (!intlThirdParty || typeof intlThirdParty.init !== 'function') {
                return;
              }

              var initFunction = intlThirdParty.init instanceof Promise ? intlThirdParty.init : _async(function (context) {
                return Promise.resolve(intlThirdParty.init(context));
              });
              return _awaitIgnored(initFunction(_this3));
            }))), function () {
              typeof initCallback === 'function' && initCallback(err, t);
              return {
                err: err,
                t: t
              };
            });
          });
        }, function (err) {
          logger.error("The instance init error: ".concat(err));
          return {
            err: err,
            t: function t(key) {
              return key;
            }
          };
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, {
    key: "language",
    get: function get() {
      return (this.i18nInstance || {}).language;
    }
  }, {
    key: "setLang",
    value: function setLang(lng, callback) {
      var formatLng = formatLang(lng, this.plugins.filter(isTypes(types.LAMGUAGE_TRANSFORMER)));
      this.i18nInstance.changeLanguage(formatLng, callback);
    }
  }, {
    key: "getLanguages",
    value: function getLanguages() {
      return this.i18nInstance.getLanguages();
    }
  }, {
    key: "setLangWithPromise",
    value: function setLangWithPromise(lng) {
      var formatLng = formatLang(lng, this.plugins.filter(isTypes(types.LAMGUAGE_TRANSFORMER)));
      return this.i18nInstance.changeLanguageWithPromise(formatLng);
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      return this.i18nInstance.getDir(lng);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      // to to something validate
      return this.i18nInstance.addResourceBundle(lng, ns, resources, deep, overwrite);
    }
  }]);

  return Intl;
}();

var I18n = new Intl();
var I18nConstructor = Intl;

export default I18n;
export { I18n, I18nConstructor, I18next as I18nCore, Intl };
